import React from "react";
import "./karkhana-ui.scss";

/**
 * The one search box for Karkhana lists: its own row under the page header (never among the
 * header buttons), a magnifier, a clear button, and the result count on the right.
 */
const SearchField = ({
  value,
  onChange,
  onSubmit,
  placeholder,
  label,
  count,
  autoCapitalize,
  children,
}: {
  value: string;
  onChange: (v: string) => void;
  /** Enter (or clearing) runs the search, for lists that search on the server only when asked. */
  onSubmit?: (v: string) => void;
  placeholder: string;
  label: string;
  count?: React.ReactNode;
  autoCapitalize?: string;
  /** Extra filters (e.g. a status select) on the same row. */
  children?: React.ReactNode;
}) => (
  <div className="kh-search-row">
    <label className="kh-search">
      <svg className="kh-search__icon" width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="9" cy="9" r="5.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
        <path d="m13.2 13.2 3.3 3.3" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
      <input
        type="search"
        className="kh-search__input"
        value={value}
        placeholder={placeholder}
        aria-label={label}
        autoCapitalize={autoCapitalize}
        autoCorrect="off"
        spellCheck={false}
        enterKeyHint="search"
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && onSubmit) onSubmit(value);
          if (e.key === "Escape" && value) {
            onChange("");
            onSubmit?.("");
          }
        }}
      />
      {value ? (
        <button
          type="button"
          className="kh-search__clear"
          aria-label="Clear search"
          onClick={() => {
            onChange("");
            onSubmit?.("");
          }}
        >
          <svg width="14" height="14" viewBox="0 0 20 20" aria-hidden="true">
            <path d="m5.5 5.5 9 9m0-9-9 9" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      ) : null}
    </label>
    {children}
    {count !== undefined ? <span className="kh-search-row__count">{count}</span> : null}
  </div>
);

export default SearchField;
